import { ILeanProductTile } from "@faire/web-api--source/indigofair/data/ILeanProductTile";
import { IProduct } from "@faire/web-api--source/indigofair/data/IProduct";

type ProductInfoProductProps = Pick<
  ILeanProductTile.ILeanProduct,
  "token" | "brand_token" | "impression_id" | "is_promoted"
> & {
  promoted_by?: Array<keyof typeof IProduct.PromotedType>;
};

export type IProductInfoClientWrapper = Pick<
  ILeanProductTile,
  "selected_product_option_token" | "badge_list" | "best_image" | "images"
> &
  ProductInfoProductProps & {
    dataTestId?: string;
  };

export const productInfoClientWrapperAdapter = (
  productTile: ILeanProductTile,
  dataTestId?: string
): IProductInfoClientWrapper => {
  return {
    token: productTile.product?.token,
    brand_token: productTile.product?.brand_token,
    impression_id: productTile.product?.impression_id,
    promoted_by: productTile.product?.promoted_by,
    is_promoted: productTile.product?.is_promoted,
    selected_product_option_token: productTile.selected_product_option_token,
    badge_list: productTile.badge_list,
    best_image: productTile.best_image,
    images: productTile.images,
    dataTestId,
  };
};
